export default "__VITE_ASSET__yVIiLq_e__"